import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import { useIsMobile } from '../hooks/useMediaQuery';
import Arrow from '../components/svg/Arrow';
import { useSetEleccion } from '../contexts/eleccionContext';
import { responsive } from '../resources/constantes.json';
import { useEleccion } from '../contexts/eleccionContext';

/**
 * Dropdown para movil con el que elegir entre varias opciones. Se usa para sustituir la lista
 * de checkbox de estadisticas, eligiendo el tipo de estadistica que mostrar cuando no es desktop
 */

const DropdownSelectorCamara = ({
  elecOptions,
  nomenclator,
  selectedCamara,
}) => {
  let [isOpen, setIsOpen] = useState(false);
  const setElecOptions = useSetEleccion();
  let camaras = elecOptions.camaras;
  const handleSelection = ({elec, camara}) => {
    setIsOpen(false)
    setElecOptions({ ...elec, selectedCamara: camara });
  };
  return (
    <SWrapper
    onSelection={handleSelection.bind(this)}
    onMenuToggle={() => {
      isOpen = !isOpen;
      setIsOpen(isOpen)}}
    >
      <SButton>
        <h3>
          {'Circunscripción ' +
            nomenclator.nomAmbitos[elecOptions.idEleccion].cam[
              selectedCamara.cam
            ].ca.toLowerCase()}
        </h3>
        {camaras.length > 1 && (
          <Arrow variant={isOpen ? 'up' : 'down'} fill="#112F50" />
        )}
      </SButton>
      <SMenu>
        {camaras.length > 1 &&
          elecOptions.camaras.map((x, i) => {
            return (
              <SMenuItem
              value={{elec: elecOptions, camara: x}}
                key={i + x.cam}
              >
                {'Circunscripción ' +
                  nomenclator.nomAmbitos[elecOptions.idEleccion].cam[
                    x.cam
                  ].ca.toLowerCase()}
              </SMenuItem>
            );
          })}
      </SMenu>
    </SWrapper>
  );
};

export default DropdownSelectorCamara;

const SWrapper = styled(Wrapper)`
  width: 100%;
  position: relative;
  background: #fff;
  border: 1px solid #C2D2F1;
  border-radius: 3px;
  margin: 10px;
  margin-top: 0;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
  z-index: 1;
  height: 6.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  & > div:first-child,
  span {
    padding-left: 1rem;
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    height: 3.5rem;
  }
`;

const SButton = styled(Button)`
  color: #283f5f;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  & h3 {
    font-size: 1.4rem;;
    font-weight: 400;
    color: #112f50;
  }
  & svg {
    margin-left: auto;
    line-height: 2rem;
    height: 2rem;
    margin-right: 2%;
  }
`;

const SMenu = styled(Menu)`
  position: absolute;
  width: 100%;
  top: 40px;
  z-index: 2;
  background: #f3f3f3;
  box-shadow: 0 10px 6px -5px rgba(0, 0, 0, 0.1);
  & > * {
    text-align: left;
  }
  & h4 {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 800;
    color: #283f5f;
    padding: 0.5rem 0;
    //box-shadow: inset 0 0px 10px 0px rgba(0, 0, 0, 0.1);
    :last-child {
      margin: 0.3rem 0;
    }
  }
`;

const SMenuItem = styled(MenuItem)`
  font-size: 1.4rem;
  padding: 0.8rem 1rem;
  cursor: pointer;
  :hover{
    color:#fff;
    background-color:#112F50; 
  }
`;
